import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgApexchartsModule } from "ng-apexcharts";
import { 
  ApexAxisChartSeries, ApexNonAxisChartSeries,
  ApexChart, 
  ApexXAxis,
  ApexDataLabels,
  ApexLegend
} from "ng-apexcharts";

import { TodoComponent } from '../../../common/widgets/todo/todo.component';

@Component({
  selector: 'app-owner-content',
  imports: [CommonModule, NgApexchartsModule, TodoComponent],
  templateUrl: './owner-content.component.html',
  styleUrls: ['../tchr-content/tchr-content.component.scss', '../ppl-content/ppl-content.component.scss', './owner-content.component.scss']
})
export class OwnerContentComponent {
  @Input() user: any;

  public chart1: ApexChart = {
    type: "area",
    height: 300,
    toolbar: {
        show: false
    }
  };
  public series1: ApexAxisChartSeries = [{
    name: "Revenue", data: [4, 5, 6, 8, 7, 9, 10, 12, 11, 13, 14, 16]
  }];
  public xaxis1: ApexXAxis = {
    categories: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
  };
  public dataLabels1: ApexDataLabels = {enabled: false};

  constructor(
    // public auth: AuthService, 
    // public alertService: AlertConfirmService, 
    // public dataService: DataService,
    // private modalService: ModalService
  ) {
    //
  }
  
  ngOnInit() {
    //
  }

}
